



















































































import Vue from "vue";
import {Component, Prop} from "vue-property-decorator";
import {
    AutomationPlayerMap, CurrentGame,
    GameAutomation,
    Player, PlayerAutomationStatus,
    PlayerColor
} from "../../../types";

// @ts-ignore
import store from "../../store";
import PlayerIcon from "./PlayerIcon.vue";
import PlayerStatusAndRole from "./PlayerStatusAndRole.vue";
import PlayerSettings from "./PlayerSettings.vue";
// @ts-ignore
import PlayerInfo from "./PlayerInfo.vue";
import MafiaButtons from "../Automations/Mafia/MafiaButtons.vue";
import EventApi from "../../api/EventsApi";
import DetectiveClubButtons from "../Automations/DetectiveClub/DetectiveClubButtons.vue";
import AutomationCodes from "../../../enums/automation-codes/AutomationCodes";

@Component({
    components: {DetectiveClubButtons, MafiaButtons, PlayerInfo, PlayerSettings, PlayerStatusAndRole, PlayerIcon},
})

export default class GamePlayer extends Vue {
    @Prop({required: true}) private readonly seat!: number;
    @Prop({required: true}) private readonly videoIsTransparent!: boolean;
    @Prop({required: true}) private readonly seatsMap!: {[key: number]: Player};
    @Prop({required: true}) private readonly cameraIsOn!: boolean;
    @Prop({required: true}) private readonly micIsOn!: boolean;

    // private isTransparent: boolean = false;

    private isPlayersSettingsVisible: {[key: number]: boolean} = {
        0: false,
        1: false,
        2: false,
        3: false,
        4: false,
        5: false,
    };

    private playerOrientationClass: string = '';
    private clipRoundWidth: string = '';
    private taskColumnWidth: string = '';

    mounted(): void
    {
        // @ts-ignore
        const observer = new ResizeObserver(entries => {
            for (let entry of entries) {
                this.setPlayerOrientationClass();
                this.setClipRoundWidth();
            }
        });

        if (typeof this.$refs.player !== 'undefined') {
            observer.observe(this.$refs.player as HTMLElement);
        }
        // this.isTransparent = this.$conferenceManager.devicesManager.cameraStatus;

        EventApi.addEventListener(EventApi.UPDATE_TASK_CONTAINER_WIDTH, this.setTaskContainerWidth);
        // EventApi.addEventListener(EventApi.CHANGE_CAMERA_STATUS, this.changeTransparentStatus);
    }

    private setTaskContainerWidth(data: any)
    {
        if (data.detail) {
            this.taskColumnWidth = data.detail;
        }
    }

    private get isTransparent(): boolean
    {
        return !store.getters.getCameraStatus;
    }

    private get player(): Player
    {
        return this.seatsMap[this.seat];
    }

    private get gameState(): any
    {
        return store.getters.getGameState;
    }

    /**
     * Статус подключения игрока (guest, active, pending)
     */
    private get playerConnectionStatus(): any
    {
        return store.getters.getPlayerConnectionStatus;
    }

    /**
     * Является гостем
     */
    private get isGuest(): boolean
    {
        return this.playerConnectionStatus === 'guest';
    }

    /**
     * Автоматизация игры
     */
    private get gameAutomation(): GameAutomation|null
    {
        return this.gameState.automation;
    }

    /**
     * Статус игрока в автоматизации игры
     */
    private get playerStatus(): PlayerAutomationStatus|null
    {
        const player: Player = this.seatsMap[this.seat];
        if (!player) {
            return null;
        }
        return store.getters.getPlayerAutomationStatus(player.id);
    }

    private get isOverlaid(): boolean
    {
        if (this.gameAutomation && this.gameAutomation.winnerId) {
            return false;
        }
        return this.isMafia && !this.playerIsMaster && this.periodName === 'day';
    }

    /**
     * Игрок выбыл из игры
     * @private
     */
    private get playerIsOutOfGame(): boolean
    {
        return this.isMafia && (this.playerStatus?.value === 2 || this.playerStatus?.value === 3);
    }

    /**
     * Карта игроков автоматизации
     */
    private get playersMap(): {[key: string]: AutomationPlayerMap}|null
    {
        if (!this.gameAutomation) {
            return null;
        }
        return this.gameAutomation.playersMap;
    }

    /**
     * Игрок-мастер в рамках автоматизации
     */
    private get playerIsMaster(): boolean|null
    {
        if (!this.playersMap) {
            return null;
        }

        if (!this.player || typeof this.playersMap[this.player.id] === 'undefined') {
            return null;
        }

        return this.playersMap[this.player.id].master;
    }

    /**
     * Игрок-мастер в рамках автоматизации
     */
    private get masterId(): string|null
    {
        if (!this.playersMap) {
            return null;
        }

        let masterId = '';

        for (let playerId in this.playersMap) {
            if (this.playersMap[playerId].master) {
                masterId = playerId;
            }
        }

        return masterId;
    }

    /**
     * Текущий раунд
     * @private
     */
    private get roundNumber(): number
    {
        if (!this.gameAutomation) {
            return 1;
        }
        return this.gameAutomation.stage.value;
    }

    /**
     * Название периода день/ночь
     * @private
     */
    private get periodName(): string
    {
        return this.roundNumber % 2 ? 'day' : 'night';
    }

    /**
     * Запущена игра "Мафия"
     * @private
     */
    private get isMafia(): boolean
    {
        return this.currentGame?.automation_code === AutomationCodes.MAFIA;
    }

    /**
     * Текущая игра
     * @private
     */
    private get currentGame(): CurrentGame|null
    {
        return store.getters.getCurrentActivity;
    }

    /**
     * Запущен Detective Club
     * @private
     */
    private get isDetectiveClub(): boolean
    {
        if (!this.currentGame) {
            return false;
        }

        return this.currentGame.automation_code === AutomationCodes.DETECTIVE_CLUB;
    }

    public getVideoHolder(): HTMLElement|null
    {
        if (typeof this.$refs.videoHolder !== 'undefined') {
            return this.$refs.videoHolder as HTMLElement;
        }
        return null;
    }

    /**
     * CSS класс определяющий вертикалный или горизонтальный сит
     * @private
     */
    private setPlayerOrientationClass(): void
    {
        const player = this.$refs.player as HTMLElement;

        if (typeof player === 'undefined') {
            return;
        }

        const width = player.offsetWidth;
        const height = player.offsetHeight;

        this.playerOrientationClass = width >= height ? 'horizontal' : 'vertical';
    }

    /**
     * Открыть настройки сита игрока
     */
    private openPlayerSettings(seat: number): void
    {
        if (this.isGuest) {
            return;
        }
        this.isPlayersSettingsVisible[seat] = true;
    }

    /**
     * Закрыть настройки сита игрока
     */
    private closePlayerSettings(seat: number): void
    {
        this.isPlayersSettingsVisible[seat] = false;
    }

    /**
     * Цвет сита
     * @param seat
     * @return {string|*}
     */
    private getSeatColor(seat: number): any
    {
        const data = this.getSeatColorData(seat);
        if (!data) {
            return '';
        }

        return data.code;
    }

    /**
     * Цвет сита
     * @param seat
     */
    private getSeatColorData(seat: number): PlayerColor|null
    {
        if (this.seatsMap[seat]) {
            return this.seatsMap[seat].color;
        }

        return null;
    }

    /**
     * Контрастный цвет сита
     * @param seat
     * @return {string|*}
     */
    private getSeatContrastColor(seat: number): string
    {
        if (this.seatsMap[seat]) {
            return this.seatsMap[seat].color.contrast;
        }

        return '';
    }

    /**
     * Порядок в сетке для нумерованных игр
     */
    private getPlayerOrder(seat: number): number|null
    {
        if (this.seatsMap[seat]) {
            const data = this.getPlayerData(this.seatsMap[seat].id);
            return data.number ? data.number.value : data.number;
        }

        return null;
    }

    /**
     * Данные игрока
     * @return {null|*}
     */
    private getPlayerData(playerId: string)
    {
        // @ts-ignore
        if (typeof store.getters.getGameState.playersData === "undefined") {
            return null;
        }

        // @ts-ignore
        let playersData = store.getters.getGameState.playersData;

        if (typeof playersData[playerId] === "undefined") {
            return null;
        }

        return playersData[playerId];
    }

    /**
     * Класс для подложки сита
     * @param seat
     * @return {string|*}
     */
    private getSeatColorBackgroundClass(seat: number): string
    {
        const data = this.getSeatColorData(seat);
        if (!data) {
            return '';
        }
        switch (data.name) {
            // @ts-ignore
            case this.$t('color.green'):
                return 'green';
            // @ts-ignore
            case this.$t('color.red'):
                return 'red';
            // @ts-ignore
            case this.$t('color.blue'):
                return 'blue';
            // @ts-ignore
            case this.$t('color.yellow'):
                return 'yellow';
            // @ts-ignore
            case this.$t('color.mint'):
                return 'brown';
            // @ts-ignore
            case this.$t('color.purple'):
                return 'violet';
            default:
                return '';
        }
    }

    /**
     * Background сита
     * @param seat
     * @return {string|null}
     */
    private getSeatBackgroundImage(seat: number): string|null
    {
        const color = this.getSeatColorData(seat);
        if (!color || !color.noVideoImageUrl) {
            return null;
        }

        return "url('" + color.noVideoImageUrl + "')";
    }

    /**
     * Статус соединения игрока
     * @param index
     * @private
     */
    private playerByIndexConnectionStatus(index: number): string
    {
        if (typeof this.seatsMap[index] === 'undefined' || !this.seatsMap[index]) {
            return '';
        }

        return this.seatsMap[index].connectionStatus;
    }

    /**
     * Предупреждение о доступе в конференцию в след.раунде\игре
     * @returns {string}
     */
    private getPendingText(): string
    {
        // @ts-ignore
        const currentActivity = store.getters.getCurrentActivity;

        if (!currentActivity) {
            return '';
        }

        const activitySettings = currentActivity.settings;
        let header = '';
        // @ts-ignore
        let text = this.$t('message.use_text_chat');
        // @ts-ignore
        header = this.$t('message.join_next_round');

        if (activitySettings.connectToConference === 3) {
            // @ts-ignore
            header = this.$t('message.join_next_game');
        }

        return `<span class="title">${header}</span><span class="text">${text}</span>`;
    }

    /**
     * Показать монетку в игре "Ангелы и демоны"
     * @param player
     */
    private showAngelCoin(player: Player): boolean
    {
        if (!player) {
            return false;
        }
        // @ts-ignore
        let automation = store.getters.getGameState.automation;

        if (!automation) {
            return false;
        }

        if (typeof automation.playersMap === 'undefined'
            || typeof automation.playersMap[player.id] === 'undefined') {
            return false;
        }

        return automation.playersMap[player.id].hasCoin;
    }

    /**
     * Выйти с сита
     * @private
     */
    private becomeGuest(): void
    {
        this.$emit('become-guest');
    }

    /**
     * установить ширину и высоту для обрезания сита
     * @private
     */
    private setClipRoundWidth(): void
    {
        if (typeof this.$refs.player === 'undefined') {
            return;
        }
        const widthCoefficient = 60;
        let fullSize: number = 0;
        if (this.playerOrientationClass === 'horizontal') {
            fullSize = (this.$refs.player as HTMLElement).offsetHeight;
        } else {
            fullSize = (this.$refs.player as HTMLElement).offsetWidth;
        }
        this.clipRoundWidth = Math.floor(fullSize / 100 * widthCoefficient) + 'px';
    }

    /**
     * Вкл/выкл микрофон
     * @private
     */
    private changeMicrophoneStatus(status: boolean): void
    {
        this.$emit('change-microphone-status', status);
    }

    /*private changeTransparentStatus(e: any): void
    {
        this.isTransparent = e.detail;
    }*/

    /**
     * Вкл/выкл камеру
     * @private
     */
    private changeCameraStatus(status: string): void
    {
        // this.isTransparent = !status;
        this.$emit('change-camera-status', status);
    }
}
